export default __webpack_public_path__ + "static/three-workers-17e7210741a0fc8bbd1ac18f132720d2.jpg";